module.exports = __webpack_public_path__ + "static/img/4.fe3fab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/4.png
// module id = ekPl
// module chunks = 0